import { FC, useState } from 'react';
import { Modal, Box, Card, Typography, Divider, MenuItem } from '@mui/material';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { TextField, Button, CircularProgress } from '@mui/material';

import API from 'src/server/serverInterface';
import { Order } from 'src/models/order';
import { is } from 'date-fns/locale';

type Props = {
  closeConfirmModal: Function;
  handleCloseConfirm: (
    event: {},
    reason: 'backdropClick' | 'escapeKeyDown'
  ) => void;
  confirmModalOpen: boolean;
  order: Order;
  isCancelling?: boolean;
};

const FulfillInternalOrderModal: FC<Props> = ({
  order,
  closeConfirmModal,
  confirmModalOpen,
  handleCloseConfirm,
  isCancelling
}) => {
  const [submitting, setSubmitting] = useState(false);

  const handleUpdate = async (values: any) => {
    console.log('SUBMITTING');

    const res = await API.execute('billing', 'UpdateOrderDispatched', {
      input: {
        ...values,
        cancelFulfilment: isCancelling === true,
        orderId: order.id
      }
    });

    console.log('result', res);

    closeConfirmModal();
    setSubmitting(false);
  };

  return (
    <Modal
      // hideBackdrop
      open={confirmModalOpen}
      onClose={handleCloseConfirm}
      aria-labelledby="modal-confirm"
      aria-describedby="modal-confirm"
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          width: 400,
          transform: 'translate(-50%, -50%)'
        }}
      >
        <Card sx={{ p: 4 }}>
          <Typography
            id="modal-confirm-heading"
            variant="h4"
            component="h2"
            sx={{ pb: 1 }}
          >
            {isCancelling ? 'Cancel Internal Order' : 'Dispatch Internal Order'}
          </Typography>

          <Divider />
          <Box sx={{ m: 2 }} />

          <Formik
            initialValues={{
              courierName: '',
              serviceName: '',
              trackingNumber: '',
              trackingUrl: 'https://'
            }}
            validationSchema={Yup.object().shape({
              ...(isCancelling
                ? {}
                : {
                    courierName: Yup.string().required('Courier is required'),
                    serviceName: Yup.string().required('Service is required'),
                    trackingNumber: Yup.string().required(
                      'Tracking Number is required'
                    ),
                    trackingUrl: Yup.string().required(
                      'Tracking URL is required'
                    )
                  })
              // .matches(
              //   /((https?):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/,
              //   'Enter a valid url!'
              // )
            })}
            onSubmit={(values, actions) => {
              setSubmitting(true);
              handleUpdate(values);
            }}
          >
            {({ errors, handleBlur, handleChange, touched, values }) => (
              <Form>
                {!submitting && (
                  <>
                    {isCancelling && (
                      <Typography>
                        Are you sure you want to cancel this internal order?
                      </Typography>
                    )}

                    {!isCancelling && (
                      <>
                        <TextField
                          select
                          name="courierName"
                          fullWidth
                          label="Courier Name"
                          variant="outlined"
                          onChange={handleChange}
                          value={values.courierName}
                          sx={{ mt: 1 }}
                          error={Boolean(
                            touched.courierName && errors.courierName
                          )}
                          helperText={touched.courierName && errors.courierName}
                        >
                          {['UPS', 'FedEx', 'Purolator', 'Canada Post'].map(
                            (s) => {
                              return (
                                <MenuItem key={s} value={s}>
                                  {s}
                                </MenuItem>
                              );
                            }
                          )}
                        </TextField>
                        <TextField
                          name="serviceName"
                          fullWidth
                          label="Service Name"
                          variant="outlined"
                          onChange={handleChange}
                          value={values.serviceName}
                          sx={{ mt: 1 }}
                          error={Boolean(
                            touched.serviceName && errors.serviceName
                          )}
                          helperText={touched.serviceName && errors.serviceName}
                        />
                        <TextField
                          name="trackingNumber"
                          fullWidth
                          label="Tracking Number"
                          variant="outlined"
                          onChange={handleChange}
                          value={values.trackingNumber}
                          sx={{ mt: 1 }}
                          error={Boolean(
                            touched.trackingNumber && errors.trackingNumber
                          )}
                          helperText={
                            touched.trackingNumber && errors.trackingNumber
                          }
                        />
                        <TextField
                          name="trackingUrl"
                          fullWidth
                          label="Tracking URL"
                          variant="outlined"
                          onChange={handleChange}
                          value={values.trackingUrl}
                          sx={{ mt: 1 }}
                          error={Boolean(
                            touched.trackingUrl && errors.trackingUrl
                          )}
                          helperText={touched.trackingUrl && errors.trackingUrl}
                        />
                      </>
                    )}
                    <Button type="submit">
                      {isCancelling ? 'Cancel Fulfillment' : 'Submit'}
                    </Button>
                    <Button onClick={() => closeConfirmModal()}>Cancel</Button>
                  </>
                )}
                {submitting && (
                  <>
                    <CircularProgress />
                  </>
                )}
              </Form>
            )}
          </Formik>
        </Card>
      </Box>
    </Modal>
  );
};

export default FulfillInternalOrderModal;
